const isLocalHost = (hostname = '') => hostname === 'localhost' || hostname === '127.0.0.1';

const LOCAL_PREVIEW_FLAG = String(import.meta.env.VITE_LOCAL_PREVIEW_MODE || '').trim().toLowerCase() === 'true';

export const LOCAL_PREVIEW_USER = {
  id: '00000000-0000-4000-8000-000000000001',
  email: 'local-preview@apnorthstar.local',
  aud: 'authenticated',
  role: 'authenticated',
  app_metadata: {
    provider: 'local-preview',
    providers: ['local-preview']
  },
  user_metadata: {
    full_name: 'Maya'
  }
};

// VITE_LOCAL_PREVIEW_PLAN=free previews the unpaid student path (onboarding → paywall).
const LOCAL_PREVIEW_FREE = String(import.meta.env.VITE_LOCAL_PREVIEW_PLAN || '').trim().toLowerCase() === 'free';

export const LOCAL_PREVIEW_PROFILE = LOCAL_PREVIEW_FREE ? {
  id: LOCAL_PREVIEW_USER.id,
  email: LOCAL_PREVIEW_USER.email,
  full_name: 'Maya',
  subscription_type: 'free',
  onboarding_completed: false,
  stripe_customer_id: null,
} : {
  id: LOCAL_PREVIEW_USER.id,
  email: LOCAL_PREVIEW_USER.email,
  full_name: 'Maya',
  subscription_type: 'pro',
  onboarding_completed: true,
  stripe_customer_id: 'local-preview-customer',
  subscription_start_date: '2026-01-01T00:00:00.000Z'
};

export const LOCAL_PREVIEW_SUBSCRIPTION = {
  id: 'local-preview-subscription',
  user_id: LOCAL_PREVIEW_USER.id,
  status: LOCAL_PREVIEW_FREE ? 'inactive' : 'active',
  prompt_limit: null,
  remaining_prompts: 'Unlimited',
  plan_name: 'Local Preview Pro'
};

export const isLocalPreviewMode = () => {
  if (!LOCAL_PREVIEW_FLAG) return false;
  if (typeof window === 'undefined') return false;
  return Boolean(import.meta.env.DEV) && isLocalHost(window.location.hostname);
};

export const getLocalPreviewBannerText = () =>
  'Local Preview mode is using a synthetic paid AP student account.';
